import LearnPageLayout from "@/components/LearnPageLayout";
import { pageSaintVsKetamine } from "./learnDataSaintVsKetamine";

const SaintVsKetaminePage = () => (
  <LearnPageLayout
    title={pageSaintVsKetamine.title}
    description={pageSaintVsKetamine.description}
    canonical={pageSaintVsKetamine.canonical}
    h1={pageSaintVsKetamine.h1}
    breadcrumbLabel={pageSaintVsKetamine.breadcrumbLabel}
    crumbs={pageSaintVsKetamine.crumbs}
    shortAnswer={pageSaintVsKetamine.shortAnswer}
    keyTakeaways={pageSaintVsKetamine.keyTakeaways}
    sections={pageSaintVsKetamine.sections}
    faqs={pageSaintVsKetamine.faqs}
    sources={pageSaintVsKetamine.sources}
    schemaJson={pageSaintVsKetamine.schemaJson}
    relatedLinks={pageSaintVsKetamine.relatedLinks}
    reviewBlock={pageSaintVsKetamine.reviewBlock}
    toc={pageSaintVsKetamine.toc}
    safetyBlock={pageSaintVsKetamine.safetyBlock}
    trademarkFooter={pageSaintVsKetamine.trademarkFooter}
    ctaBand={pageSaintVsKetamine.ctaBand}
  />
);

export default SaintVsKetaminePage;
